/**
 * Scroll-reveal pass, added 2026-08-23.
 * Marks each homepage section for a fade+rise on first scroll-into-view.
 * Grid sections (collection cards, product cards) get a per-item stagger
 * instead of one whole-block reveal. Hero is excluded — it has its own
 * load-in animation in motion-contract.css.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function markGridOrSection(section) {
    var grid = section.querySelector(
      '.resource-list--grid, .section-resource-list ul, .product-grid, [class*="resource-list"] > ul'
    );
    if (grid && grid.children.length > 1) {
      Array.prototype.forEach.call(grid.children, function (child, i) {
        child.style.setProperty('--reveal-delay', Math.min(i, 5) * 100 + 'ms');
        child.setAttribute('data-reveal', '');
      });
      return;
    }
    section.setAttribute('data-reveal', '');
  }

  function init() {
    // Homepage only. On product and collection pages the risk is not worth it:
    // a reveal that fails to fire hides real merchandise from a customer, and
    // lazy-loaded imagery on those templates shifts layout enough to make that
    // a live possibility. Nothing there needs an entrance animation.
    // Decide from the URL, not the Theme object: this script runs before
    // Theme is defined, so relying on it silently animated every page.
    // Homepage and collection pages only. Product pages are deliberately
    // excluded: nothing there benefits, and the downside is a customer not
    // seeing the thing they came to buy.
    var path = location.pathname.replace(/\/+$/, '');
    var isHome = path === '' || /^\/[a-z]{2}(-[a-z]{2})?$/i.test(path);
    var isCollection = path.indexOf('/collections/') !== -1 && path.indexOf('/products/') === -1;
    if (!isHome && !isCollection) return;

    var sections = document.querySelectorAll('#MainContent [id^="shopify-section-"]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.id.indexOf('__section_hero') !== -1) return;
      if (section.id.indexOf('_hero') !== -1 && section.querySelector('.hero')) return;
      markGridOrSection(section);
    });

    var targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;

    function reveal(el) {
      el.classList.add('is-visible');
      observer.unobserve(el);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Reveal when it comes into view, OR when it is already above the
          // viewport. Lazy-loaded images shift the layout, which can carry an
          // element from below the fold to above it without it ever
          // intersecting. Without this it would stay invisible forever.
          if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
            reveal(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    // Safety net: anything still hidden but sitting at or above the fold after
    // the page settles gets shown. Content must never be lost to an animation.
    function sweep() {
      document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) reveal(el);
      });
    }
    window.addEventListener('load', function () { setTimeout(sweep, 400); });
    window.addEventListener('resize', sweep);

    // Hard guarantee. Whatever happens above, nothing stays hidden: after a few
    // seconds every remaining element is revealed outright. An animation is
    // never worth losing a product listing over.
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach(reveal);
    }, 2500);

    Array.prototype.forEach.call(targets, function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
